import { Download } from 'phosphor-react'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import FilesHelper from '../../common/libs/Files'
import i18n from '../../lang/idiomas'

const ExpedienteComentarios = () => {
  const tipos_expedientes = useSelector(state => state.expedientes.tipos_expedientes)
  const tipo_expediente_seleccionado = useSelector(
    state => state.expedientes.tipo_expediente_seleccionado,
  )
  const tipos_expedientes_comentarios = useSelector(
    state => state.expedientes.tipos_expedientes_comentarios,
  )

  const comentarios = Array.isArray(tipos_expedientes_comentarios)
    ? tipos_expedientes_comentarios
    : []

  const comentarios_expediente_seleccionado = comentarios.filter(
    com => com.tipo_expediente === tipos_expedientes[tipo_expediente_seleccionado].tipo_expediente
  )

  const [imagenesComentarios, setImagenesComentarios] = useState({})

  useEffect(() => {
    if (!comentarios_expediente_seleccionado.length) return

    const fetchImages = async () => {
      const imagenesPendientes = comentarios_expediente_seleccionado.filter(
        com => com.tiene_imagen === 'S' && !imagenesComentarios[`${com.tipo_expediente}${com.numero_linea_nota}`]
      )

      for (let i = 0; i < imagenesPendientes.length; i++) {
        const com = imagenesPendientes[i]

        if (com.tiene_imagen === 'S') {
          try {
            let imagen = await FilesHelper.downloadFile(
              null,
              null,
              `tiposexpedientescomentarios/fichero/?t=8&tipo_expediente=${com.tipo_expediente}&numero_linea_nota=${com.numero_linea_nota}`,
              true,
            )

            const base64 = `data:image/jpeg;base64,${imagen.fichero}`

            setImagenesComentarios(prev => ({
              ...prev,
              [`${com.tipo_expediente}${com.numero_linea_nota}`]: base64
            }))
          } catch (err) {
            console.error('Error descargando imagen del comentario: ', err)
          }
        }
      }
    }

    fetchImages()
  }, [comentarios_expediente_seleccionado])

  const descargarDocumento = e => {
    FilesHelper.downloadFile(
      null,
      null,
      `tiposexpedientescomentarios/fichero/?token=${e.currentTarget.getAttribute('data-token')}&t=7`,
    )
  }

  if (!comentarios_expediente_seleccionado.length) return <></>

  return (
    <div className='container'>
      <div id='tt-pageContent'>
        <div className='container container-comentarios-expedientes'>
          <section className='comentarios-expedientes row justify-content-center'>
            {comentarios_expediente_seleccionado.map((com, i) => (
              <div className='comentario-expediente col-12 mb-4'>
                <div
                  key={i}
                  className='comentario-cabecera row justify-content-center'>
                  <div
                    className={`comentario-descripcion ${com?.nombre_archivo ? 'col-lg-9 col-md-8 col-10' : 'col-12'
                      }`}>
                    <h6>{com.descripcion_reducida}</h6>
                  </div>
                  {com?.nombre_archivo && (
                    <div className='comentario-documento col-lg-3 col-md-4 col-2'>
                      <button
                        className='btn-comentario-documento px-2'
                        data-token={com.token}
                        onClick={descargarDocumento}>
                        <Download
                          size={18}
                          className='icono-comentario-documento'
                        />
                        <span className='d-none d-md-inline'>{i18n.t('expedientes.downdoc')}</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className='comentario-detalle row justify-content-center'>
                  <div
                    className={`comentario-notas ${com?.tiene_imagen === 'S' ? 'mb-md-0 mb-3 col-lg-8 col-md-7 col-12' : 'col-12'
                      }`}>
                    <article>{com.notas}</article>
                  </div>
                  {com?.tiene_imagen === 'S' && (
                    <div className='comentario-imagen col-lg-4 col-md-5 col-12'>
                      <img
                        src={imagenesComentarios[`${com.tipo_expediente}${com.numero_linea_nota}`]}
                        alt={com.descripcion_reducida}
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </section>
        </div>
      </div>
    </div>
  )
}

export default ExpedienteComentarios
